export const JF_ISSUE_TYPE    = 'Issue Type';             // NOSONAR
export const JF_ISSUE_KEY     = 'Issue key';              // NOSONAR
export const JF_ISSUE_ID      = 'Issue id';               // NOSONAR
export const JF_SUMMARY       = 'Summary';                // NOSONAR
export const JF_STATUS        = 'Status';                 // NOSONAR
export const JF_DUE_DATE      = 'Due date';               // NOSONAR
export const JF_LABELS        = 'Labels';                 // NOSONAR
export const JF_LABELS_1      = 'Labels.1';               // NOSONAR
export const JF_LABELS_2      = 'Labels.2';               // NOSONAR
export const JF_LABELS_3      = 'Labels.3';               // NOSONAR
export const JF_LABELS_4      = 'Labels.4';               // NOSONAR
export const JF_PARENT        = 'Parent';                 // NOSONAR
export const JF_PARENT_KEY    = 'Parent key';             // NOSONAR
export const JF_PARENT_SUM    = 'Parent summary';         // NOSONAR
export const JF_EPIC_LINK     = 'Custom field (Epic Link)';          // NOSONAR
export const JF_EPIC_STATUS   = 'Custom field (Epic Status)';        // NOSONAR
export const JF_SP            = 'Custom field (Story Points)';       // NOSONAR
export const JF_TGT_START     = 'Custom field (Target start)';       // NOSONAR
export const JF_TGT_END       = 'Custom field (Target end)';         // NOSONAR
export const JF_PLAN_START    = 'Custom field (Planned Start)';      // NOSONAR
export const JF_PLAN_END      = 'Custom field (Planned End)';        // NOSONAR
export const JF_SPRINT        = 'Custom field (Sprint)';             // NOSONAR
export const JF_TEAM          = 'Custom field (Team)';               // NOSONAR
export const JF_CONTRIB_TEAM  = 'Custom field (Contributing Team)';  // NOSONAR
export const JF_PROGRAM       = 'Custom field (Program)';            // NOSONAR
export const JF_RELEASE       = 'Custom field (Release)';            // NOSONAR
export const JF_DEP_SUMMARY   = 'Custom field (Dependency Summary)';  // NOSONAR
export const JF_IT_POV        = 'Custom field (Dependency Summary)';  // NOSONAR — maps to IT POV in this org's Jira
export const JF_IT_RAG        = 'Custom field (IT RAG Status)';       // NOSONAR
export const JF_IT_PM         = 'Custom field (IT Product Manager)';  // NOSONAR
export const JF_TIER          = 'Tier';                               // NOSONAR
export const JF_RANK          = 'Rank';                               // NOSONAR
export const JF_WORKSTREAM    = 'Is Workstream';                      // NOSONAR
